const GalleryView = require('../../components/productgallery/hpe.product.gallery.view');

module.exports = (function () {
    function initialize() {
      if (!document.querySelector('.hpe-product-detail-page')) return false;
      document.querySelectorAll('.hpe-product-gallery').forEach((el) => new GalleryView({el}));
    }

    // Public methods
    return { initialize };
})();
